export interface iPromoteCode {
  id?: number;
  name: string;
  sequence?: string;
  expire_at?: number | null;
  type: number; //0-云币 1-周期卡 2-现金券
  opertor_id?: number;
  opertor_name?: string;
  open?: boolean;
  number: number | null;
  created_at?: number | null;
  extend: iPromoteExtend;
  exchange_limit: number | null;
  gen_type: number;
  intro?: string;
}

export interface iPromoteExtend {
  amount: number | null;
  weekAmount: number | null;
  cashAmount: number | null;
  title: string;
  valid_days: number | null;
  valid_start_ts: number | null;
  valid_end_ts: number | null;
  money_limit: number | null;
}
export interface iPromoteQuery {
  id?: number | null;
  name: string;
  opr_name: string;
  pack_id?: number;
  status?: number;
  sequence?: string;
}

export enum eType {
  /**
   * 云币
   */
  COIN = 1,
  /**
   * 周期卡
   */
  WEEKCARD = 2,
  /**
   * 现金券
   */
  CASH = 3,
  /**
   * 第三方码
   */
  THIRDCODE = 4,
   /**
   * 云朵
   */
  CLOUD= 5,
}

export enum eRechargeType {
  /**
   * 不限制金额
   */
  NOLIMIT = 1,
  /**
   * 限制金额
   */
  LIMIT = 2,
}

export enum eVilidityDateType {
  /**
   * 按领取时间
   */
  GETDATE = 1,
  /**
   * 固定时间段
   */
  FIXEDATE = 2,
}
export enum eGenerateType {
  /**
   * 预生成 Prebuilt
   */
  PREBUILT = 1,
  /**
   * 使用时生成
   */
  USEGENERATE = 2,
}
